// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__t9dI-","productName":"Table_productName__180Js"};